import { format } from "date-fns";

export function useFormat(date: string){
    return format(
        new Date(date),
        "MM - dd - yyy"
      )
}